import { createConsumer } from "@rails/actioncable";

const websocketUrl = process.env.REACT_APP_WEBSOCKET_URL || "ws://localhost:5002/cable";
const consumer = createConsumer(websocketUrl);

export default consumer;